import { render, staticRenderFns } from "./EditorBlockArea.vue?vue&type=template&id=55abc3eb&scoped=true"
import script from "./EditorBlockArea.vue?vue&type=script&lang=js"
export * from "./EditorBlockArea.vue?vue&type=script&lang=js"
import style0 from "./EditorBlockArea.vue?vue&type=style&index=0&id=55abc3eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55abc3eb",
  null
  
)

export default component.exports